import { useMemo } from 'react';
import { isString } from 'lodash';
import { isRoman, toArabic } from 'typescript-roman-numbers-converter';
import { UseNumberFormat, useTranslations } from 'src/hooks';
import { IRangeAndSetData } from 'src/typings/filter';

export const useConvertToFormat = (data: (IRangeAndSetData | string)[], attribute?: string, useSorting?: boolean) => {
  const { numberSeparator } = UseNumberFormat();
  const { getTranslations } = useTranslations();

  const currentData = useMemo(() => {
    const mapped = data?.map((item: IRangeAndSetData | string) => {
      const optionIsString = isString(item);
      return {
        key: optionIsString ? item : item?.key,
        text: optionIsString ? getTranslations(numberSeparator(item, attribute)) : item?.text,
        value: optionIsString ? item : item?.value,
      };
    });
    if (useSorting === false) {
      return mapped;
    }
    const isAllIsRoman = !!(mapped?.length && mapped?.every((item) => isRoman(item.value) || isRoman(item.text)));
    return isAllIsRoman
      ? mapped?.sort((a, b) => toArabic(a.text)?.toString().localeCompare(toArabic(b.text)?.toString() || '', undefined, { numeric: true, sensitivity: 'base' }) || 0)
      : mapped?.sort((a, b) => a?.text?.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }));
  }, [data, getTranslations]);

  return {
    currentData: currentData || [],
  };
};
